import React from 'react';
import { Chip, Icon } from '@mui/material';

export interface IChipStatusProps {
    label: string;
    value: string;
    hasLabel?: boolean | false;
    hasIcon?: boolean | false;
    chipSettings?: IChipsSettingProps[];
}

export interface IChipsSettingProps {
    value: string;
    iconName: string;
    iconColor: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined;
    iconNameDefault?: string | '';
    iconColorDefault?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined;
}

export const ChipStatus: React.FC<IChipStatusProps> = ({ label, value, hasLabel, chipSettings }) => {
    const chipInfo = chipSettings?.find(setting => setting.value == value) || { iconName: chipSettings?.[0]?.iconNameDefault, iconColor: chipSettings?.[0]?.iconColorDefault ?? 'info' };

    return value !== null ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {hasLabel && <span style={{ fontWeight: 'bold' }}>{label}:</span>}
            <Chip
                icon={chipInfo.iconName ? <Icon>{chipInfo.iconName}</Icon> : undefined}
                label={value}
                color={chipInfo.iconColor}
                variant="outlined"
                size="small"
                sx={{mt: -.2}}
            />
        </div>
    ) : (
        <React.Fragment>{/* No value provided */}</React.Fragment>
    );
};
